module.exports = __webpack_public_path__ + "static/img/introduce_m@2x.71ad0aae.png";